import { pickResolver } from '@/helpers/resolver';
import { demoCurrencyResolver, GAMES_CURRENCIES_RESOLVERS } from './resolvers';
import type { GamesCurrencies, GamesCurrenciesContext } from './types';

export const getGamesCurrencies = (
  context: GamesCurrenciesContext
): GamesCurrencies =>
  pickResolver(
    GAMES_CURRENCIES_RESOLVERS,
    demoCurrencyResolver,
    context
  ).resolve(context);

export const getGamesCurrenciesKey = (context: GamesCurrenciesContext) =>
  getGamesCurrencies(context).join();

export const parseGamesCurrenciesKey = (key: string) =>
  key.split(',') as GamesCurrencies;
